'use strict';

/**
 * @ngdoc routes
 * @name observatoireApp.routes.titresMiniers
 * @description
 * Configuration des routes pour les titres miniers
 */
angular
  .module('observatoireApp')
  .config(['$stateProvider', routesConfig]);

function routesConfig($stateProvider) {
  $stateProvider
    .state('main.titres-miniers', {
      url: '/titres-miniers',
      templateUrl: 'app/titres-miniers/titres-miniers.html',
      controller: 'TitresMinierCtrl',
      controllerAs: 'vm'
    })
    .state('main.titres-miniers-details', {
      url: '/titres-miniers/:id',
      templateUrl: 'app/titres-miniers/titres-miniers-details.html',
      controller: 'TitresMinierDetailsCtrl',
      controllerAs: 'vm'
    });
}
